import VueScrollTo from "vue-scrollto"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueScrollTo, {
    /* デフォルトの設定 options : https://www.npmjs.com/package/vue-scrollto */
    duration: 1000,
    easing: "ease"
  })
})
